import { IMPORTFILELIST_SEARCH, IMPORTFILELIST_PAGE } from '../actions/importfilelistactions';

const state = { search: '', page: 0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [IMPORTFILELIST_SEARCH]: ({ commit }, search) => {
        commit(IMPORTFILELIST_SEARCH, search);
    },
    [IMPORTFILELIST_PAGE]: ({ commit }, page) => {
        commit(IMPORTFILELIST_PAGE, page);
    }
};

const mutations = {
    [IMPORTFILELIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [IMPORTFILELIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};